import type { Cookie } from 'src/cookies';
import { getCookieWithKey } from 'src/cookies';
import { analyticsConsentCookieCategoryKey } from './cookie-types/analytical-cookies';

const GOOGLE_ANALYTICS_COOKIE_NAME = '_ga';

export const GOOGLE_ANALYTICS_COOKIE: Cookie = getCookieWithKey(
  GOOGLE_ANALYTICS_COOKIE_NAME,
  analyticsConsentCookieCategoryKey
);
